// extracted by mini-css-extract-plugin
module.exports = {"userButton":"AuthButton_userButton__1ahXe","icon":"AuthButton_icon__1XRS4","text":"AuthButton_text__SoXhG"};